export const CARD_ITEM_SETTINGS = {
    sm: {
        width: '242px',
        height: '136px',
    },
    md: {
        width: '441px',
        height: '331px',
    },
    lg: {
        width: '546px',
        height: '308px',
    },
};
export const MAX_CAROUSEL_CARDS = 10;
